import React, { Component } from "react";
import { connect } from "react-redux";

import { basketActions, configActions, messageActions, pageActions } from "../../actions";
import PartialInputAmount from "../InputAmount";
import Denominator from "../denominator/Denominator";
import FadedPanel from "../feedback.js";
import { ArrowForwardIcon, ShoppingCartIcon, EditIcon, getProduktInfoIcon } from "../../utils/components/icons";
import { scrollToTop, scrollTo } from "../../utils/functions";
import CurrencyItem from '../../type/currency-item.js';
import { Tooltip } from "../../utils/components/Tooltip";

class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amountModel: 0,
      inBasket: false,
      focus: false,
      denominator: false,
      windowPosition: null,
      locked: false,
      fade: false,
      item: this.props.item ? CurrencyItem.create(this.props.item) : null
    };
    this.handleClickAddToBasket = this.handleClickAddToBasket.bind(this);
    this.handleShowBasket = this.handleShowBasket.bind(this);
    this.handleDenominationOpen = this.handleDenominationOpen.bind(this);
    this.handleUpdateAmount = this.handleUpdateAmount.bind(this);
    this.handleChangeAmount = this.handleChangeAmount.bind(this);
    this.updateAmountModel = this.updateAmountModel.bind(this);
    this.handleUpdateAmountModel = this.handleUpdateAmountModel.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    let item = state.item;
    // MaKond changes item price
    if (item && props.item && item.rate !== props.item.rate) {
      item.recreate({ rate: props.item.rate });
    }
    return { ...state, item };
  }

  setFade() {
    this.setState({ fade: true });
    setTimeout(() => this.setState({ fade: false }), 1200);
  }

  updateAmountModel(value) {
    this.setState({
      amountModel: value
    });
  }

  getBasketFullMessage() {
    const maxBasketSize = this.props.basketStorage.getMaxBasketSize();
    let message = "Leider ist eine Bestellung über " + maxBasketSize + " Sorten je Warenkorb nicht möglich.";
    if (this.props.configStorage.isAnkaufShop()) {
      message = "Ein Ankauf von mehr als " + maxBasketSize + " Position pro Warenkorb ist nicht möglich.";
    }
    return message;
  }

  async handleClickAddToBasket(event) {
    let currency = this.state.item.clone();
    if (this.props.configStorage.sessionWillEnd()) {
      this.props.dispatch(configActions.restartSession(this.props.configStorage.getRequestData("session_ping")));
    }
    if (currency.amountModel !== this.state.amountModel && Number(this.state.amountModel) > 0) {
      currency.setAmountModel(this.state.amountModel);
      if (!this.props.configStorage.isAnkaufShop()) {
        currency.doUpdateAmountModel();
      }
    }
    if (currency.isZero()) {
      let parent = event.target;
      // set focus on input to indicate missing amount
      while (parent) {
        if (parent.querySelector('input.ser-input')) {
          parent.querySelector('input.ser-input').focus();
          break;
        }
        parent = parent.parentNode;
      }
      return;
    }

    if (this.props.basketStorage.isBasketFull()) {
      let message = "Leider ist eine Bestellung über " + this.props.basketStorage.getMaxBasketSize() + " Sorten je Warenkorb nicht möglich.";
      if (this.props.configStorage.isAnkaufShop()) {
        message = "Ein Ankauf von mehr als " + this.props.basketStorage.getMaxBasketSize() + " Position pro Warenkorb ist nicht möglich.";
      }
      this.props.dispatch(messageActions.showMessage(
        this.props.configStorage.getHtmlId(),
        '.ser-adderbox', message
      )
      );
    } else if (this.props.basketStorage.isPriceTooHigh(currency.getEuroAmount()) && !this.props.configStorage.isAnkaufShop()) {
      this.props.dispatch(messageActions.showMessage(
        this.props.configStorage.getHtmlId(),
        '.ser-adderbox',
        'Der Gegenwert übersteigt die Obergrenze von ' + this.props.basketStorage.getMaxSumText() + ' Euro. Bitte reduzieren Sie den Gegenwert.')
      );
    } else if (this.props.basketStorage.isSumTooHigh(currency.getEuroAmount()) && !this.props.configStorage.isAnkaufShop()) {
      this.props.dispatch(messageActions.showMessage(
        this.props.configStorage.getHtmlId(),
        '.ser-adderbox',
        'Mit dieser Sorte übersteigt Ihr Warenkorb die Obergrenze von ' + this.props.basketStorage.getMaxSumText() + ' Euro. Bitte reduzieren Sie den Gegenwert.')
      );
    } else if (this.props.configStorage.isAnkaufShop()) {
          // ✅ Ankauf: validate WITHOUT modifying real basket
          const currentSum = this.props.basketStorage.sum.getPrice();
          const newSum = currentSum + currency.getEuroAmount();
          const numericLimit = this.props.basketStorage.numericLimit;
    
          if (
            numericLimit !== null &&
            !isNaN(numericLimit) &&
            newSum > numericLimit
          ) {
          const formattedLimit =
            this.props.basketStorage.numericLimit !== null && !isNaN(this.props.basketStorage.numericLimit)
              ? this.props.basketStorage.numericLimit.toLocaleString("de-DE")
              : "";
    
          const warningMessage =
            "Mit dieser Sorte übersteigt Ihr Ankauf die zulässige Obergrenze von {value} Euro. Bitte reduzieren Sie die gewählte Menge.".replace(
              "{value}",
              formattedLimit
            );
    
            this.props.dispatch(
              messageActions.showWarningMessage(
                this.props.configStorage.getHtmlId(),
                ".ser-adderbox",
                warningMessage,
                "50%",
                "25%"
              )
            );
            return;
          }

          this.props.dispatch(basketActions.addItem(currency));

          const item = CurrencyItem.create(this.props.item);
          item.reset()
            .setSelectedDenomination(null)
            .setSelectedIso();
          this.setState({
            amountModel: 0,
            inBasket: true,
            fade: true,
            item
          });
          this.setFade();      
      } else {
      this.props.dispatch(basketActions.addItem(currency));
      const item = CurrencyItem.create(this.props.item);
      item.reset()
        .setSelectedDenomination(null)
        .setSelectedIso();
      this.setState({
        amountModel: 0,
        inBasket: true,
        fade: true,
        item
      });
      this.setFade();
    }
  }

  handleShowBasket() {
    if (this.props.basketStorage.numItems() > 0) {
      this.setState({ locked: true });
      scrollToTop();
      this.props.dispatch(pageActions.setCartPage());
      if (this.props.configStorage.sessionWillEnd()) {
        this.props.dispatch(configActions.restartSession(this.props.configStorage.getRequestData("session_ping")));
      }
    } else {
      let txt = "Sie haben noch keine Sorte in den Warenkorb gelegt.";
      this.props.dispatch(
        messageActions.showMessage(
          this.props.configStorage.getHtmlId(),
          ".ser-basketanchor",
          txt
        )
      );
    }
  }

  async handleUpdateAmount(event) {
    const target = event.currentTarget || event.target;
    if (!target) return;
    this.state.item.setAmountModel(target.value);
    if (!this.props.configStorage.isAnkaufShop()) {
      this.state.item.doUpdateAmountModel();
    }
    this.setState({
      amountModel: this.state.item.amountModel
    });
  }

  async handleChangeAmount(event) {
    const target = event.currentTarget || event.target;
    if (!target) return;
    this.state.item.setAmountModel(target.value);
    this.setState({
      amountModel: this.state.item.amountModel
    });
  }

  handleDenominationOpen() {
    this.setState({ denominator: true, windowPosition: window.scrollY });
    scrollToTop();
  }

  handleUpdateAmountModel(event) {
    this.state.item.setSelectedIso(event.target.value);
    if (!this.props.configStorage.isAnkaufShop()) {
      this.state.item.doUpdateAmountModel();
    }
    this.setState({
      amountModel: this.state.item.amountModel
    });
  }

  updateItem() {
    scrollTo(this.state.windowPosition);
    this.setState({ denominator: false, windowPosition: null, amountModel: undefined });
  }

  render() {
    if (!this.state.item) return null;
    let item = this.state.item;
    let iso = item.getSelectedIso();
    let itemAmount = item.hasSelectedDenomination ? item.amountModel : this.state.amountModel;
    return (
      <li
        id={this.props.configStorage.getHtmlId() + "-" + item.kennziffer}
        className="ser-item ser-iblock"
        aria-label={"Sorte: " + item.name}
      >
        <div className="ser-image-box col-12 justify-content-center">
          <img
            alt={"Flagge für " + item.name}
            className="img-responsive"
            src={this.props.configStorage.getImgUrl(item.image)}
          />
        </div>
        <div className="ser-itembox ser-currency p-one">
          <div className="ser-section row" aria-live="polite">
            <span className="ser-label ser-iblock col-10">
              <h4 className="itemTitle" aria-level="3">{item.name}</h4>
            </span>
            {item.produktInfo ? (
              <span className="col-2">
                <Tooltip className="fs-4 mt-2" icon={getProduktInfoIcon()}>{item.produktInfo}</Tooltip>
              </span>
            ) : null}
          </div>
          <div className="ser-section row">
            <span className="ser-label ser-iblock col-6">ISO:</span>
            <span className="ser-grey text-end col-6">{String(item.iso).toUpperCase()}</span>
          </div>
          <div className="ser-section row">
            <span className="ser-label ser-iblock col-6">Kurs:</span>
            <span className="ser-grey text-end col-6">{item.getDisplayRate()}</span>
          </div>
          <div className="ser-section row">
            <span className="ser-label ser-iblock col-4">Betrag:</span>
            <div className="ser-iblock ser-select-currency text-end col-8">
              <select
                className="ser-select-currency"
                name="isoSelect"
                value={iso}
                disabled={this.props.configStorage.isAnkaufShop()}
                onChange={this.handleUpdateAmountModel}
                aria-label="Währung"
              >
                {item.selectionArray.map((arrayItem, key) => {
                  return <option className="ser-2col" key={arrayItem.value} value={arrayItem.value}>{arrayItem.text}</option>;
                })}
              </select>
              <PartialInputAmount
                className="ser-input"
                value={itemAmount}
                updateValue={this.updateAmountModel}
                onchange={this.handleChangeAmount}
                onblur={this.handleUpdateAmount}
                aria-label="Betrag"
              />
            </div>
          </div>
          {this.props.configStorage.isAnkaufShop() ? "" :
            <div className="ser-section row">
              <span className="ser-label ser-iblock col-6">Stückelung:</span>
              {item.hasDenominator ?
                <>
                  <button type="button"
                    onClick={this.handleDenominationOpen}
                    className="ser-denomination ser-iblock btn-link text-end col-6"
                    aria-label="Stückelung"
                  >
                    <span className="text-black">{item.hasSelectedDenomination ? 'ändern' : 'gemischt'}</span><EditIcon />
                  </button>
                  <Denominator
                    hidden={!this.state.denominator}
                    item={item}
                    locked={this.state.locked || this.props.basketStorage.locked}
                    onclose={this.updateItem}
                  />
                </>
                : <div className="ser-denomination ser-iblock text-end col-6">
                  <span>gemischt</span>
                </div>
              }
            </div>
          }
          <div className="ser-section row" aria-live="polite">
            <span className="ser-label ser-iblock ser-ovpricelabel col-6">
              Gegenwert:
            </span>
            <span className="text-end col-6">{item.toString()}</span>
            {this.props.configStorage.isKundenShop() || this.props.configStorage.isLightShop()
              ? <span className="fs-6 col-12 ser-label">{" "}
                {this.props.configStorage.isLightShop()
                  ? "ggf. zuzüglich Versand- und Bearbeitungsgebühren"
                  : <>zzgl. {this.props.basketStorage.getShippingCosts().toEuro()} für Versand nach Hause</>
                }
              </span>
              : null
            }
          </div>
        </div>

        <div className="ser-overlayWrapper" aria-label="Zum Warenkorb">
          <FadedPanel fade={this.state.fade} />
          <div className={"ser-adderbox" + (this.props.basketStorage.isBasketFull() ? " p-1" : "")}>
          {!this.props.configStorage.isLightShop() ?
              (!this.props.basketStorage.isBasketFull()
                ? <button type="button"
                  className="ser-basketadder ser-iblock btn-link float-end"
                  onClick={this.handleClickAddToBasket}
                  aria-label={itemAmount + " " + String(item.iso).toUpperCase() + " in den Warenkorb legen"}
                >
                  In den Warenkorb
                  <ArrowForwardIcon />
                </button>
                : <div className="ser-basketadder ser-ibloc text-center fs-6">
                  {this.getBasketFullMessage()}
                </div>
              )
             : null}
            <button type="button"
              aria-label="Warekorb öffnen"
              className={"btn-link float-start " + (this.state.inBasket ? "d-block" : "d-none")}
              onClick={this.handleShowBasket}
            >
              <ShoppingCartIcon />
            </button>
          </div>
        </div>
      </li>
    );
  }
}

export default connect(store => {
  return {
    basketStorage: store.basketStorage,
    configStorage: store.configStorage
  };
})(Item);
